import { resolveComponent as i, openBlock as t, createElementBlock as o, createVNode as a, createStaticVNode as c } from "vue";
import { _ as r } from "./_plugin-vue_export-helper-dad06003.js";
import { X as l } from "./XIcon-e21df3cc.js";
const f = {
  components: {
    XIcon: l
  }
}, d = {
  type: "button",
  class: "rounded-lg p-2 bg-transparent ct-bg-1--hover focus:ct-ring-focus--shadow focus:outline-none"
};
function p(n, e, g, m, B, C) {
  const s = i("XIcon");
  return t(), o("button", d, [
    a(s, {
      class: "h-4 w-4 text-gray-400 dark:text-neutral-500 ct-bg-1--hover",
      "aria-hidden": "true"
    })
  ]);
}
const k = /* @__PURE__ */ r(f, [["render", p]]), u = {}, _ = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function h(n, e) {
  return t(), o("svg", _, e[0] || (e[0] = [
    c('<g filter="url(#filter0_b_8866_1975)"><path d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z" fill="black" fill-opacity="0.2"></path><path d="M1.5 28C1.5 13.3645 13.3645 1.5 28 1.5C42.6355 1.5 54.5 13.3645 54.5 28C54.5 42.6355 42.6355 54.5 28 54.5C13.3645 54.5 1.5 42.6355 1.5 28Z" stroke="white" stroke-width="3"></path><path d="M39.375 26.5328C40.5417 27.1849 40.5417 28.8151 39.375 29.4672L23.625 38.2705C22.4583 38.9226 21 38.1075 21 36.8033L21 19.1967C21 17.8925 22.4583 17.0774 23.625 17.7295L39.375 26.5328Z" fill="white"></path></g><defs><filter id="filter0_b_8866_1975" x="-12" y="-12" width="80" height="80" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feGaussianBlur in="BackgroundImageFix" stdDeviation="6"></feGaussianBlur><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_8866_1975"></feComposite><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_8866_1975" result="shape"></feBlend></filter></defs>', 2)
  ]));
}
const v = /* @__PURE__ */ r(u, [["render", h]]);
export {
  k as B,
  v as a
};
